import React, { Component } from "react";
import PropTypes from 'prop-types';
import PostComment from "./PostComment"
import Comments from "./Comments"
import { db, firebase } from '../firebase';

const loginStyle = {
  marginTop: 20,
  backgroundColor: "white",
  marginBottom: 20
};
const h2Style = {
  paddingLeft: 10,
  paddingTop: 5,
  fontFamily: "Audiowide, cursive",
  color: "cadetblue"
};

const ArticleComments = (props, {authUserId, authUser, userName, inGameName }) =>
<React.Fragment>
  <div style={loginStyle}  className="container rounded">
  <h2 style={h2Style}>Comments</h2>
  <ArticleCommentDetails authUserId={authUserId} articleId={props.articleId} userName={userName} inGameName={inGameName} />
  </div>
</React.Fragment>

ArticleComments.contextTypes = {
  authUser: PropTypes.object,
  userName: PropTypes.string,
  inGameName: PropTypes.string,
  authUserId: PropTypes.string
};

class ArticleCommentDetails extends Component {
  constructor(props) {
    super(props);

    this.state = { commentData: [] };
  }

  componentDidMount () {
      var thethis = this;

      db.getComments(thethis.props.articleId).then(snapshot =>
        thethis.setState(() => ({ commentData: snapshot.Comments }))
      );

    }

  render() {
    const {
      Comment,
      error,
    } = this.state;

    var buttonStyle={
      marginTop: 10
    }

    var comments = this.state.commentData;
    var thethis = this;
    return (
      <React.Fragment>
      <Comments comments={comments} articleId={this.props.articleId} />
      <PostComment comments={comments} authUserId={this.props.authUserId} articleId={this.props.articleId} userName={this.props.userName} inGameName={this.props.inGameName}  />
      </React.Fragment>
    );

  }
}


export default ArticleComments;



// WEBPACK FOOTER //
// ./src/Articles/ArticleComments.js